import { Autocomplete, CircularProgress } from "@mui/material";
import React from "react";
import {
  CustomFormLabel,
  CustomShrinkTextField,
  CustomTextField,
} from "../formsComponents";
import { debounce } from "lodash";
import { api } from "../../api/api";
import {
  IInsurerCodeAutoSearchProps,
} from "./AutoCompleteSearches.types";
import axios from "axios";
import { IInsurerCode } from "../../redux/insurer/insurer.types";

 

export const InsurerCodeV2AutoSearch: React.FC<IInsurerCodeAutoSearchProps> = (
  props
) => {
  const {
    value,
    onSelect,
    label,
    disabled,
    fullWidth = true,
    hasShrinkTextField,
    shrinkTextFieldSize,
    error,
    errorMessage,
    placeholder,
    isValueStoredByName,
  } = props;
  const [options, setOptions] = React.useState<readonly IInsurerCode[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearchText] = React.useState<any>("");
  const initialLoad = React.useRef(false);

  const fetchSuggestion = async (
    value: string,
    isById: boolean,
    cancelToken: any
  ) => {
    setLoading(true);
    try {
      const url = `/insurance/get-insurer-code?status=ACTIVE&column=insurer_code&column=name&value=${value}`;

      const res = await api.get(url, {
        cancelToken: cancelToken,
      });
      const data: IInsurerCode[] = res.data.data;
      setOptions(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const debounceFn = React.useCallback(debounce(fetchSuggestion, 800), []);

  const getOptionLabel = (option: IInsurerCode) => {
    return `${option.insurer_code || ""} (${option.name})`;
  };
  React.useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();

    if (search && search !== value) {
      debounceFn(search, false, cancelTokenSource.token);
    }
    // Cleanup function to cancel the request when the component unmounts
    return () => {
      cancelTokenSource.cancel("Operation canceled due to component unmount.");
    };
  }, [search]);

  React.useEffect(() => {
    if (value && !initialLoad.current) {
      debounceFn(value, true, null);
    }
  }, [value]);

  return (
    <>
      {!hasShrinkTextField && label && <CustomFormLabel>{label}</CustomFormLabel>}
      <Autocomplete
        id="google-map-demo"
        fullWidth
        sx={{
          ".MuiOutlinedInput-root": {
            paddingTop: "0px",
            paddingBottom: "0px",

            color: "rgb(38, 38, 38)",
            width: "100%",
          },
        }}
        getOptionLabel={getOptionLabel}
        // isOptionEqualToValue={(option, value) =>
        //   typeof option === "string"
        //     ? option === value
        //     : //@ts-ignore
        //       option.interested_party_code === value.interested_party_code
        // }
        // filterOptions={(x) => x}
        options={options}
        autoComplete
        includeInputInList
        value={
          isValueStoredByName
            ? options.find((option) => option.name === value) || null
            : options.find((option) => option.insurer_code === value) || null
        }
        loading={loading}
        disabled={disabled}
        noOptionsText="Type to search"
        //@ts-ignore
        onChange={(
          event: React.ChangeEvent<HTMLElement>,
          newValue: IInsurerCode | null
        ) => {
          setOptions(newValue ? [...options] : options);
          if (newValue) {
            onSelect(newValue);
          } else {
            onSelect({
              dim_insurer_code_id: null,
              insurer_code: null,
              insurer_code_id: -1,
              name: "",
              email: "",
              company_email: "",
              phone_number: "",
              address: "",
              city: null,
              unit_or_suite: null,
              province_or_state: null,
              postal_code: null,
              country: null,
              agency_code: "",
              sub_code: "",
              llm_prompt: "",
              logo_file: null,
              csio_code: "",
              agency_bill_trust_payable_g_or_l_code: "",
              direct_bill_receivable_g_or_l_code: "",
              agency_bill_revenue_g_or_l_code: "",
              direct_bill_revenue_g_or_l_code: "",
              default_billing: null,
              status: "",
              insert_ts: "",
            });
          }
        }}
        onInputChange={(event, newInputValue) => {
          if ((event && event.type === "change") || !newInputValue) {
            setSearchText(newInputValue);
            initialLoad.current = true;
          }
        }}
        renderInput={(params) => {
          if (hasShrinkTextField) {
            return (
              <CustomShrinkTextField
                {...params}
                fullWidth={fullWidth}
                placeholder={placeholder}
                label={label}
                size={shrinkTextFieldSize}
                error={errorMessage ? true : false}
                helperText={errorMessage}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }
          return (
            <CustomTextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
              error={errorMessage ? true : false}
              helperText={errorMessage}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          );
        }}
      />
    </>
  );
};
